export const EmptyReferences = {
  UNDEFINED: undefined,
  OBJECT: {},
};
